export default "__VITE_ASSET__BAtetltF__"